import type { SVGProps } from 'react';

export const ReveIcon = ({
  className,
  width,
  height,
}: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    role="img"
    aria-label="Reve"
    className={className}
    width={width}
    height={height}
  >
    <image
      href="/img/providers/reve.png"
      width="100"
      height="100"
      preserveAspectRatio="xMidYMid slice"
    />
  </svg>
);
